import { EventCard } from "../../components/activities/EventCard";
import type { EventGridComponent } from "../../types";
import { RuntimeLink } from "../../runtime/RendererRuntime";
import { resolveLinkHref } from "../../utils/links";

/** Event grid renderer with cards and optional CTA link. */
export function EventGridRenderer({ component }: { component: EventGridComponent }) {
  const { items, ctaHref, ctaLabel } = component.content;
  const resolvedCtaHref = resolveLinkHref(ctaHref);
  return (
    <section>
      <div className="grid gap-4 sm:gap-6 md:grid-cols-3">
        {items.map((e, i) => (
          <EventCard key={`${e.title}-${i}`} {...e} />
        ))}
      </div>
      {resolvedCtaHref && ctaLabel ? (
        <div className="mt-4">
          <RuntimeLink href={resolvedCtaHref} className="inline-flex items-center gap-1 text-[#00B862] hover:underline" style={{ fontFamily: "var(--font-aleo)" }}>
            {ctaLabel}
            <span aria-hidden>›</span>
          </RuntimeLink>
        </div>
      ) : null}
    </section>
  );
}


